export const setUserData = (propsData, stateData, stateKey) => {
  if ((!Array.isArray(stateData) && stateData !== null) || (Array.isArray(stateData) && stateData.length)) {
    return stateData;
  } else {
    if (propsData.hasOwnProperty(stateKey)) {
      return propsData[stateKey];
    }
  }
};
